<div [@toastTrigger]="(toast.showsToast$ | async) ? 'open' : 'close'" [class]="toast.toastState$ | async" > 
    <div style="max-width: 200px;">
        <div class="toast-title mb-1" *ngIf="(toast.toastState$ | async) === TOAST_STATE.success">{{'label-title.success-message' | translate}}</div>
        <div class="toast-title mb-1" *ngIf="(toast.toastState$ | async) === TOAST_STATE.danger">{{'label-title.error-message' | translate}}</div>
        {{ toast.toastMessage$ | async }}
    </div>

    <a class=" ms-2" (click)="dismiss()">
        <small class="c-pointer">
            {{'button-title.close' | translate}}
        </small>
    </a>
    <div class="progress-bar" *ngIf="(toast.counter$ | async) as progress" [style.width.%]="progress"></div>
</div>
